import React, { useState, useEffect } from "react";
import "./style.css";
import Header from "../../../componente/header";
import Paginacao from "../../../componente/paginacao";
import Impressora from "../../../assets/Impressora.png";
import api from "../../../services/api";
import LoadingScreen from "../../../componente/aguarde";
import { podeImprimir } from "../../../componente/permissoes";

const API_URL = "v1/relatorio";
const AUTOCOMPLETE_URL = "v1/relatorio/filtro";

const RelVendaEmAberto = () => {
  const [offset, setOffset] = useState(0);
  const [abusca, setabusca] = useState("");
  const [lista, setlista] = useState([]);
  const [qtdetotalpag, setqtdetotalpag] = useState(0);
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputValue1, setInputValue1] = useState("");
  const [inputValue2, setInputValue2] = useState("");

  const [listaequipe, setlistaequipe] = useState([]);
  const [listaVendedor1, setlistaVendedor1] = useState([]);
  const [listacidade, setlistacidade] = useState([]);

  const [edtcodequipe, setedtcodequipe] = useState(0);
  const [codvendedor1, setcodvendedor1] = useState(0);
  const [edtcidade, setedtcidade] = useState("0");
  const [edtuf, setedtuf] = useState("");

  const { DateTime } = require("luxon");

  const dt = new Date();

  const date1 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const date2 =
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    dt.getDate().toString().padStart(2, "0");

  const [dt1, setdt1] = useState(date1);
  const [dt2, setdt2] = useState(date2);

  const [ativo, setAtivo] = useState("T");

  const handleEquipeSelecionado = (equip) => {
    setInputValue(equip.descricao);
    setedtcodequipe(equip.codequipe);
    setlistaequipe([]);
  };

  const handleInputChangeEquipe = async (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/equipe`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaequipe(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistaequipe([]);
      setedtcodequipe(0);
    }
  };

  const handleVendedor1Selecionado = (ven) => {
    setInputValue1(ven.nome);
    setcodvendedor1(ven.codfuncionario);
    setlistaVendedor1([]);
  };

  const handleInputChangeVendedor1 = async (e) => {
    const value = e.target.value;
    setInputValue1(value);

    if (value.length > 2) {
      setLoading(true);
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/vendedor1`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistaVendedor1(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      } finally {
        setLoading(false);
      }
    } else {
      setlistaVendedor1([]);
      setcodvendedor1(0);
    }
  };

  const handleCidadeSelecionado = (cid) => {
    setInputValue2(cid.cidade + " - " + cid.uf);
    setedtcidade(cid.cidade);
    setedtuf(cid.uf);
    setlistacidade([]);
  };

  const handleInputChangeCidade = async (e) => {
    const value = e.target.value;
    setInputValue2(value);

    if (value.length > 2) {
      try {
        const response = await api.get(`${AUTOCOMPLETE_URL}/cidade`, {
          params: { busca: value },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        });
        setlistacidade(response.data);
      } catch (error) {
        console.log("ops! ocorreu um erro: " + error);
      }
    } else {
      setlistacidade([]);
      setedtcidade("0");
      setedtuf("");
    }
  };

  const imprimir = async () => {
    setLoading(true);

    try {
      const response = await api.get(`v1/impressoes/relvendaemaberto`, {
        responseType: "arraybuffer",
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          codvendedor: codvendedor1,
          cidade: edtcidade,
          uf: edtuf,
          usuario: localStorage.getItem("tempUsuario"),
          dt1,
          dt2,
          ativo,
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      const blob = new Blob([response.data], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  const fetchListar = async () => {
    setLoading(true);

    try {
      const response = await api.get(`${API_URL}/vendaemaberto`, {
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          codvendedor: codvendedor1,
          cidade: edtcidade,
          uf: edtuf,
          dt1,
          dt2,
          offset,
          ativo,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });
      setlista(response.data);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchListar();
  }, [offset, abusca, edtcidade,
    edtcodequipe,
    ativo,
    codvendedor1,
    dt1,
    dt2,]);

  const fetchListarPaginas = async () => {
    try {
      const response = await api.get(`${API_URL}/vendaemaberto/pagtotal8`, {
        params: {
          busca: abusca,
          codequipe: edtcodequipe,
          codvendedor: codvendedor1,
          cidade: edtcidade,
          uf: edtuf,
          dt1,
          dt2,
          ativo,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      });

      setqtdetotalpag(response.data.paginatotal);
    } catch (error) {
      console.log("ops! ocorreu um erro: " + error);
    }
  };

  useEffect(() => {
    fetchListarPaginas();
  }, [lista]);

  function FormataData(props) {
    return props
      ? DateTime.fromISO(props).plus({ hours: 3 }).toFormat("dd/MM/yyyy")
      : null;
  }

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <h1 className="ms-4">Relatório Vendas Em Aberto</h1>
          <p className="ms-4">
            Rotina para listar todas as vendas que estão em aberto na empresa.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
            <label className="form-label" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código, nome ou cpf"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => {
                setabusca(e.target.value);
                setOffset(0);
              }}
            />
          </div>

          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-12">
            <label htmlFor="periodo" className="form-label">
              de...
            </label>
            <br />
            <input
              type="date"
              id="periodo"
              className="form-control"
              placeholder="Data Inicio"
              value={dt1}
              onChange={(e) => setdt1(e.target.value)}
            />
          </div>

          <div className="col-xl-2 col-lg-3 col-md-3 col-sm-12">
            <label htmlFor="periodo" className="form-label">
              Para...
            </label>
            <br />
            <input
              type="date"
              id="periodo2"
              className="form-control"
              placeholder="dtnascimento"
              value={dt2}
              onChange={(e) => setdt2(e.target.value)}
            />
          </div>

          <div className="col-xl-1 col-lg-3 col-md-2 col-sm-4">
            <label className="form-label">Ativo</label>
            <div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="ativo"
                  id="todos"
                  value="T"
                  checked={ativo === "T"}
                  onChange={(e) => setAtivo(e.target.value)}
                />
                <label className="form-check-label" htmlFor="todos">
                  Todos
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="ativo"
                  id="ativo"
                  value="S"
                  checked={ativo === "S"}
                  onChange={(e) => setAtivo(e.target.value)}
                />
                <label className="form-check-label" htmlFor="ativo">
                  Ativo
                </label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="ativo"
                  id="inativo"
                  value="N"
                  checked={ativo === "N"}
                  onChange={(e) => setAtivo(e.target.value)}
                />
                <label className="form-check-label" htmlFor="inativo">
                  Inativo
                </label>
              </div>
            </div>
          </div>

          <div className="col-xl-1 col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center">
            <button className="btn" onClick={imprimir} disabled={!podeImprimir("/relatorio/vendaemaberto")}>
              <img src={Impressora} alt="Imprimir" />
              <label>Imprimir</label>
            </button>
            {loading && <LoadingScreen />}
          </div>
        </div>

        <div className="row">         
          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label htmlFor="equipe" className="form-label">
              Equipe
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue}
              onChange={handleInputChangeEquipe}
            />
            <ul className="autocomplete-list">
              {listaequipe.map((equipe) => (
                <li
                  key={equipe.codequipe}
                  onClick={() => handleEquipeSelecionado(equipe)}
                >
                  {equipe.descricao}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label htmlFor="equipe" className="form-label">
              Vendedor
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue1}
              onChange={handleInputChangeVendedor1}
            />
            <ul className="autocomplete-list">
              {listaVendedor1.map((ven) => (
                <li
                  key={ven.codfuncionario}
                  onClick={() => handleVendedor1Selecionado(ven)}
                >
                  {ven.nome}
                </li>
              ))}
            </ul>
          </div>

          <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
            <label htmlFor="cidade" className="form-label">
              Cidade
            </label>
            <input
              type="text"
              className="form-control"
              value={inputValue2}
              onChange={handleInputChangeCidade}
            />
            <ul className="autocomplete-list">
              {listacidade.map((cid) => (
                <li
                  key={cid.cidade}
                  onClick={() => handleCidadeSelecionado(cid)}
                >
                  {cid.cidade} - {cid.uf}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="col-sm-12 table table-hover">
            <thead>
              <tr>
                <th>Código</th>
                <th>Vencimento</th>
                <th>Cód. Cliente</th>
                <th>Cliente</th>
                <th>Rota</th>
                <th>Chefe de Equipe</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              {lista.map((item) => (
                <tr key={item.coddetalhe}>
                  <th>{item.coddetalhe}</th>
                  <th>{FormataData(item.dtvencimento)}</th>
                  <th>{item.codcliente}</th>
                  <th>{item.cliente}</th>
                  <th>{item.rota}</th>
                  <th>{item.chefeequipe}</th>
                  <th>
                    {parseFloat(item.valor).toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                  </th>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="3">Quantidade de linhas: {lista.length}</td>
                <td colSpan="5">
                  Total:{" "}
                  {lista
                    .reduce(
                      (total, item) => total + parseFloat(item.valor),
                      0
                    )
                    .toLocaleString("pt-BR", {
                      style: "currency",
                      currency: "BRL",
                    })}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row d-flex justify-content-center">
          <Paginacao
            limit={20}
            total={qtdetotalpag}
            offset={offset}
            setOffset={setOffset}
          />
        </div>
      </div>
    </>
  );
};

export default RelVendaEmAberto;
